__turbopack_context__.v({
  "deck": "SeeInAction-module-scss-module__8CGxGG__deck",
  "heading": "SeeInAction-module-scss-module__8CGxGG__heading",
  "section": "SeeInAction-module-scss-module__8CGxGG__section",
});
